import React from 'react'
import PropTypes from 'prop-types'

import useSetState from 'hooks/useSetState'
import generateID from 'functions/generateID'

import Button from 'components/Button'
import FormField from 'components/forms/FormField'

import styles from './styles.scss'

const defaultState = {
  title: '',
  url: '',
}

const createLink = (props, state) => {
  const { callbacks: { createLink: createLinkFn } } = props
  const { title, url } = state

  const link = {
    key: generateID(),
    title,
    url,
  }

  createLinkFn(link)
}

const AddLink = (props) => {
  const [state, setState] = useSetState(defaultState)
  const { title, url } = state

  return (
    <div className={styles.root}>
      <FormField label="Title" style={{ marginRight: 5 }}>
        <input type="text" value={title} onChange={e => setState({ title: e.target.value })} />
      </FormField>

      <FormField label="URL" style={{ marginRight: 5 }}>
        <input type="text" value={url} onChange={e => setState({ url: e.target.value })} />
      </FormField>

      <Button
        disabled={!title || !url}
        onClick={() => createLink(props, state)}
        size="medium"
        style={{ marginTop: 6 }}
        text="Add"
      />
    </div>
  )
}

AddLink.propTypes = {}

export default AddLink
